import { VisualSearchIcon } from '@va/icons';
import { Button } from '@va/ui/design-system';

type ExampleQuestionProps = {
  label: string;
  onClick: (label: string) => void;
  disabled: boolean;
  disabledTooltipText: string;
};

export const ExampleQuestion = ({ label, onClick, disabled, disabledTooltipText }: ExampleQuestionProps) => {
  return (
    <Button
      text={label}
      size='small'
      color='quinary'
      icon={() => <VisualSearchIcon className='w-11u h-11u shrink-0' />}
      className='!bg-gray-wild-sand hover:!bg-black-lighter-06 block !h-auto !py-4u'
      textClasses='text-interface-regular leading-interface-regular text-wrap'
      onClick={() => onClick(label)}
      disabled={disabled}
      tooltip={disabled ? disabledTooltipText : undefined}
      tooltipProps={{ placement: 'top' }}
    />
  );
};
